import { SplashBox } from "../../components";
import AppointmentsDisplay from "../../components/appointments-display";

export default function AppointmentsDisplayPage() {

    return <div className="appointments-display-page-container">
        <AppointmentsDisplay />
        <SplashBox />
    </div>
}